import { type VariantProps, cva } from 'class-variance-authority';
import type { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import type { CommonProps } from '../../types';
import { VenueId } from '@beat-venues/common-types';

export interface SpinnerProps
    extends CommonProps,
        VariantProps<typeof SpinnerStyles> {
    venueId: VenueId;
    children?: ReactNode;
}

export const SpinnerStyles = cva(
    'animate-spinner-logo m-auto h-20 lg:h-28 my-8 w-auto'
);

export const Spinner = ({
    className,
    venueId,
    testId = 'spinner',
}: SpinnerProps): JSX.Element => {
    return (
        <img
            data-testid={testId}
            alt="spinner"
            className={twMerge(SpinnerStyles({ className }))}
            src={`/assets/${venueId}/logo/logo_small.svg`}
        />
    );
};
